import { domains } from '../constant/url'

// 热搜相关作品-kol-seo
export const getRecomBookListUrl = (page: string | number): string => {
  return `${domains.pc}/recommendbooklist/${
    page && page !== 1 ? `p${page}/` : ''
  }`
}

// 书籍详情页链接（根据环境前缀指向 www.qidian.com）
export const getBookDetailUrl = (bookId: string | number): string => {
  return `/book/${bookId}/`
}

export const getCatalogUrl = (bookId: string | number): string => {
  return `/book/${bookId}/catalog/`
}

export const getChapterUrl = (
  bookId: string | number,
  chapterId: string | number,
): string => {
  return `/chapter/${bookId}/${chapterId}/`
}
